class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();

    this.handlePurchaseTypeChange = this.handlePurchaseTypeChange.bind(this);
    this.updateSellingPlan = this.updateSellingPlan.bind(this);
    this.variantChangeHandler = this.variantChangeHandler.bind(this);
  }

  connectedCallback() {
    this.initWidget();

    const variantInput = document.querySelector('.product-variant-id');
    if (variantInput) {
      variantInput.addEventListener('change', this.variantChangeHandler);
    }
  }

  initWidget() {
    this.purchaseTypeInputs = this.querySelectorAll('input[name="purchase-type"]');
    this.sellingPlanSelect = this.querySelector('.frequency__select-box');
    this.hiddenInput = this.querySelector('.selected-selling-plan-id');

    this.purchaseTypeInputs.forEach(input => {
      input.removeEventListener('change', this.handlePurchaseTypeChange);
      input.addEventListener('change', this.handlePurchaseTypeChange);
    });

    if (this.sellingPlanSelect) {
      this.sellingPlanSelect.removeEventListener('change', this.updateSellingPlan);
      this.sellingPlanSelect.addEventListener('change', this.updateSellingPlan);
    }

    this.updateSellingPlan();
  }

  handlePurchaseTypeChange() {
    this.updateSellingPlan();
  }

  updateSellingPlan() {
    const purchaseType = this.querySelector('input[name="purchase-type"]:checked')?.value;

    if (!this.hiddenInput) return;

    if (purchaseType === 'subscribe') {
      this.hiddenInput.disabled = false;
      this.hiddenInput.setAttribute('name', 'selling_plan');

      if (this.sellingPlanSelect) {
        this.hiddenInput.value = this.sellingPlanSelect.value;
      }
    } else {
      this.hiddenInput.value = '';
      this.hiddenInput.disabled = true;
      this.hiddenInput.removeAttribute('name');
    }
  }

  variantChangeHandler(event) {
    const sectionId = this.dataset.sectionId;
    const productUrl = this.dataset.productUrl;
    const variantId = event.target.value;

    fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const newWidget = responseHTML.querySelector('#esa__subscription-widget');

        if (!newWidget) return;

        this.innerHTML = newWidget.innerHTML;
        this.initWidget();
      });
  }
}

customElements.define('subscription-widget', SubscriptionWidget);